var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "lableFormContainer" }, [
      "inStyle" === _vm.crew
        ? _c("h2", [_vm._v("Instagram Handle")])
        : _c("h2", [_vm._v("Username")])
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.account.username,
          expression: "account.username"
        }
      ],
      attrs: { type: "text", id: "username" },
      domProps: { value: _vm.account.username },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.account.username = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    "inStyle" !== _vm.crew
      ? _c("div", { staticClass: "lableFormContainer" }, [
          _c("h2", [_vm._v("Link zu deinem Instagram Profil")])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _vm._m(2),
    _vm._v(" "),
    "inStyle" !== _vm.crew
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.additionalQuestions.instagram,
              expression: "additionalQuestions.instagram"
            }
          ],
          attrs: {
            type: "text",
            id: "instagram",
            name: "additionalQuestions.instagram"
          },
          domProps: { value: _vm.additionalQuestions.instagram },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.additionalQuestions.instagram = $event.target.value
            }
          }
        })
      : _vm._e(),
    _vm._v(" "),
    "inStyle" !== _vm.crew
      ? _c("div", { staticClass: "lableFormContainer" }, [
          _c("h2", [_vm._v("Link zu deinem TikTok Profil")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Bitte gib mindestens einen Link zu deinem Instagram- oder TikTok-Profil an"
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm._m(3),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    "inStyle" !== _vm.crew
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.additionalQuestions.tiktok,
              expression: "additionalQuestions.tiktok"
            }
          ],
          attrs: {
            type: "text",
            id: "tiktok",
            name: "additionalQuestions.tiktok"
          },
          domProps: { value: _vm.additionalQuestions.tiktok },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.additionalQuestions.tiktok = $event.target.value
            }
          }
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "lableFormContainer" }, [
      "inStyle" === _vm.crew
        ? _c("h2", [_vm._v("E-Mail Adresse")])
        : _c("h2", [_vm._v("Email-Adresse")])
    ]),
    _vm._v(" "),
    _vm._m(5),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.account.email,
          expression: "account.email"
        }
      ],
      attrs: { type: "text", id: "email" },
      domProps: { value: _vm.account.email },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.account.email = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _vm._m(7),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.account.password,
          expression: "account.password"
        }
      ],
      attrs: { type: "password", id: "password1" },
      domProps: { value: _vm.account.password },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.account.password = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _vm._m(8),
    _vm._v(" "),
    _vm._m(9),
    _vm._v(" "),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.account.repeatedPassword,
          expression: "account.repeatedPassword"
        }
      ],
      attrs: { type: "password", id: "password2" },
      domProps: { value: _vm.account.repeatedPassword },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.account.repeatedPassword = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "error errorBox",
        staticStyle: { display: "none" },
        attrs: { id: "usernameError" }
      },
      [_c("strong", [_vm._v("Bitte beantworte die Frage")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "errorBox error",
        staticStyle: { display: "none" },
        attrs: { id: "instagramErrorUrl" }
      },
      [_c("strong", [_vm._v("Bitte gib eine gültige URL ein")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "error errorBox",
        staticStyle: { display: "none" },
        attrs: { id: "instagramError" }
      },
      [_c("strong", [_vm._v("Bitte beantworte die Frage")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "errorBox error",
        staticStyle: { display: "none" },
        attrs: { id: "tiktokErrorUrl" }
      },
      [_c("strong", [_vm._v("Bitte gib eine gültige URL ein")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "error errorBox",
        staticStyle: { display: "none" },
        attrs: { id: "tiktokError" }
      },
      [_c("strong", [_vm._v("Bitte beantworte die Frage")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "error errorBox",
        staticStyle: { display: "none" },
        attrs: { id: "emailError" }
      },
      [_c("strong", [_vm._v("Bitte beantworte die Frage")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lableFormContainer" }, [
      _c("h2", [_vm._v("Passwort")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "error errorBox",
        staticStyle: { display: "none" },
        attrs: { id: "password1Error" }
      },
      [
        _c("strong", [
          _vm._v("Bitte beantworte die Frage / überprüfe die Übereinstimmung")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lableFormContainer" }, [
      _c("h2", [_vm._v("Passwort wiederholen")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "error errorBox",
        staticStyle: { display: "none" },
        attrs: { id: "password2Error" }
      },
      [
        _c("strong", [
          _vm._v("Bitte beantworte die Frage / überprüfe die Übereinstimmung")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c664b2be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c664b2be","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountRegistration.vue
// module id = 247
// module chunks = 2